import { all, fork } from 'redux-saga/effects'

import appStoreSagas from './appStore'

export default function * rootSaga () {
  yield all([
    fork(appStoreSagas)
  ])
}
